import * as idb from 'idb';
import { resizeImage } from "../helpers/images";

const DB_NAME = 'kpi-offline-db';
const STORE_NAME = 'pending-kpis';

const dbPromise = idb.openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
  },
});

export const saveOfflineKpi = async (action) => {
  // Resize image if it exists in the action
  if (action.data?.image) {
    console.log("Resizing image...");
    const resizedImage = await resizeImage(action.data.image);
    action.data.image = resizedImage;
  } else if (action.data?.imageURL) {
    console.log("Resizing blob...");
    const response = await fetch(action.data.imageURL);
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    const resizedImage = await resizeImage(file);
    action.data.image = resizedImage;
  }
  const db = await dbPromise;
  return db.add(STORE_NAME, {
    action,
    timestamp: Date.now(),
  });
};

export const getPendingKpis = async () => {
  const db = await dbPromise;
  return db.getAll(STORE_NAME);
};

export const deletePendingKpi = async (id) => {
  const db = await dbPromise;
  return db.delete(STORE_NAME, id);
}; 